import { combineReducers } from "redux";

import sidebar from "./sidebarReducers";
import instagram from "./instagramReducer";

export default combineReducers({
  sidebar,
  instagram
});
